import React from 'react'
import LancamentoVendasListPageContainer from './LancamentoVendasListPageContainer'

export class LancamentoVendasListPage extends React.Component {
  render() {
    return <LancamentoVendasListPageContainer {...this.props} />
  }
}
